<template>
  <div class="c-future-mobile">
    <!-- Mobile screen 1 -->
    <div class="c-future-mobile__screen-select" v-if="sectionThisId === 0">

      <!-- Landscape select -->
      <div class="c-future-mobile__landscape__select">
        <div class="o-section__container">
          <h2 class="o-section__title">Explore the future energy landscape</h2>
        </div>
        <div class="o-aspect">
          <div class="o-aspect__inner"></div>
        </div>
        <div class="c-future-mobile__btn">
          <button @click="setRoute('landscape'), goToSection(1)"><svg class="icon icon-touch"><use xlink:href="#icon-touch"></use></svg><span class="u-hide">More</span></button>
        </div>
      </div>

      <!-- Prosumer select -->
      <div class="c-future-mobile__prosumer__select">
        <div class="o-section__container">
          <h2 class="o-section__title">Explore a day in the life of a domestic prosumer of the future</h2>
        </div>
        <div class="o-aspect">
          <div class="o-aspect__inner"></div>
        </div>
        <div class="c-future-mobile__btn">
          <button @click="setRoute('prosumer'), goToSection(1)"><svg class="icon icon-touch"><use xlink:href="#icon-touch"></use></svg><span class="u-hide">More</span></button>
        </div>
      </div>
    </div>

    <!-- Landscape hotspot -->
    <div class="c-future-mobile__landscape__hotspots" v-if="sectionThisId === 1 && route === 'landscape'">
      <div class="o-section__container">
        <div class="o-title-close">
          <h2 class="o-section__title o-title-close__title">Future energy landscape</h2>
          <button class="o-title-close__btn" @click="goToSection(0)"><svg class="icon icon-cross"><use xlink:href="#icon-cross"></use></svg><span class="u-hide">Back</span></button>
        </div>
        <my-hotspots :show-detail="showDetail" :items="landscapeItems"></my-hotspots>
      </div>
    </div>

    <!-- Prosumer hotspots -->
    <div class="c-future-mobile__prosumer__hotspots" v-if="sectionThisId === 1 && route === 'prosumer'">
      <div class="o-section__container">
        <div class="o-title-close">
          <h2 class="o-section__title o-title-close__title">A day in the life of a domestic prosumer of the future</h2>
          <button class="o-title-close__btn" @click="goToSection(0)"><svg class="icon icon-cross"><use xlink:href="#icon-cross"></use></svg><span class="u-hide">Back</span></button>
        </div>

        <ul class="c-prosumer-menu">
          <li class="c-prosumer-menu__item" :class="['c-prosumer-menu__item--' + (index + 1)]" @click="showDetail(index)" v-for="(item, index) in prosumerItems">
            <p class="c-prosumer-menu__time"><span>{{ item.time }}</span></p>
            <p class="c-prosumer-menu__text">{{ item.title }}</p>
            <div class="c-prosumer-menu__image">
              <div class="c-prosumer-menu__image__inner">
                <p class="c-prosumer-menu__index">{{ index + 1 }}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- Landscape detail -->
    <div class="c-future-mobile__detail" v-if="sectionThisId === 2">
      <div class="c-mobland" :class="colorClass('c-mobland--', itemId + 1)">
        <div class="o-aspect--10">
          <figure class="c-mobland__image o-aspect__inner">
            <my-image :section="section" :route="route"></my-image>
          </figure>
          <div class="c-mobland__controls">
            <button class="c-mobland__button--back" @click="goToSection(1)"><svg class="icon icon-cross"><use xlink:href="#icon-cross"></use></svg><span class="u-hide">Back</span></button>
            <button class="c-mobland__button--prev" @click="showDetail(itemId - 1)" v-if="itemId !== 0"><svg class="icon icon-left-arrow"><use xlink:href="#icon-left-arrow"></use></svg><span class="u-hide">Previous</span></button>
            <button class="c-mobland__button--next" @click="showDetail(itemId + 1)" v-if="itemId !== sectionItems.length - 1"><svg class="icon icon-right-arrow"><use xlink:href="#icon-right-arrow"></use></svg><span class="u-hide">Next</span></button>
          </div>
        </div>
        <div class="o-section__container c-mobland__text">
          <p class="c-mobland__time" v-if="section.time">{{ section.time }}</p>
          <div class="c-mobland__text__header">
            <h3 class="c-mobland__title">{{ section.title }}</h3>
          </div>
          <div class="c-mobland__body" v-html="section.body"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import MyHotspots from '@/components/single/MyHotspots'
import MyImage from '@/components/standard/my-image'
import mixins from '@/mixins'
// import { IconRightArrow, IconLeftArrow, IconCross, IconTouch } from '@/components/standard/my-icons'

export default {
  name: 'my-future-mobile',
  components: {
    MyHotspots,
    MyImage
    // IconRightArrow,
    // IconLeftArrow,
    // IconCross,
    // IconTouch
  },
  mixins: [mixins],
  data () {
    return {
      sectionThisId: 0,
      itemId: null,
      route: null
    }
  },
  computed: {
    device () {
      return this.$store.state.device
    },
    landscapeItems () {
      return this.$store.state.content['future'] || []
    },
    prosumerItems () {
      return this.$store.state.content['prosumer'] || []
    },
    sectionItems () {
      if (this.route === 'landscape') {
        return this.landscapeItems
      } else if (this.route === 'prosumer') {
        return this.prosumerItems
      } else {
        return null
      }
    },
    section () {
      return this.sectionItems[this.itemId]
    }
  },
  methods: {
    setRoute (route) {
      this.route = route
    },
    goToSection (id) {
      this.scrollToSection(null, () => {
        this.sectionThisId = id
      })
    },
    showDetail (id) {
      // console.log(id)
      this.sectionThisId = 2
      this.itemId = id
    },
    colorClass (baseClass, index) {
      if (this.route === 'prosumer' && index) {
        return baseClass + index
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// MyFutureMobile.vue?78f4acd3